import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import Yup from '../../../../utils/yupExtensions';

import { useGetEducationLevelsHook } from '../../../../utils/utilityHooks';

import FormField from '../../../UI/FormUI/FormField/FormField';
import FormSelectField from '../../../UI/FormUI/FormSelectField/FormSelectField';
import FormDateField from '../../../UI/FormUI/FormDateField/FormDateField';
import FormFileField from '../../../UI/FormUI/FormFileField/FormFileField';
import Button from '../../../UI/Buttons/Button/Button';

import styles from './CustomDateForm.module.css';

function CustomDateForm({ onSubmit, ...props }) {
    const { t } = useTranslation();

    const createValidationSchema = useCallback((education_level) => {
        if (education_level === 'no_formal_education') {
            return Yup.object({

                startDate: Yup.string(),
                endDate: Yup.string(),

            });
        } else {
            return Yup.object({
                startDate: Yup.string().required(t('forms.education.required')),
                endDate: Yup.string().required(t('forms.education.required')),

            });
        }
    }, [t]);

    const [validationSchema, setValidationSchema] = useState(createValidationSchema(''));

    const formik = useFormik({
        initialValues: {
            startDate: '',
            endDate: '',
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            onSubmit({
                startDate: values.startDate !== '' ? values.startDate : 0,
                endDate: values.endDate !== '' ? values.endDate : 0
            });
        },
    });
    return (
        <form onSubmit={formik.handleSubmit} {...props}>

            <div>
                <FormDateField
                    name="startDate"
                    placeholder={t('forms.workExperience.start_date')}
                    hasBorder
                    type="date"
                    onChange={formik.handleChange}
                    value={formik.values.startDate}
                    error={formik.touched.startDate && formik.errors.startDate}
                />
            </div>
            <div>
                <FormDateField
                    name="endDate"
                    placeholder={t('forms.workExperience.end_date')}
                    hasBorder
                    type="date"
                    onChange={formik.handleChange}
                    value={formik.values.endDate}
                    error={formik.touched.endDate && formik.errors.endDate}
                />
            </div>
            <div>
                <Button type="submit" className={styles.button}>{t('forms.education.add')}</Button>
            </div>
        </form>
    );
}

export default CustomDateForm;